import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";


// Custom components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
function Security() {
    const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userRole = loginData?.role;
  const storedUsername = loginData?.username;
  const firstNameStored = loginData?.firstName;
  const lastNameStored = loginData?.lastName;

 
   const navigate = useNavigate();
     const [formData, setFormData] = useState({
       username: "",
       password: "",
       passwordConfirm: "",
     });
       useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      username: storedUsername || "",
    }));
  }, [storedUsername]);
   
     const handleChange = (e) => {
       setFormData({ ...formData, [e.target.name]: e.target.value });
     };
   
     const handleSubmit = async (e) => {
       e.preventDefault();
   if (userRole === "ROLE_SUPER") {
  toast.warn("SUPER role password cannot be reset!");
  return;
}

       if (formData.password !== formData.passwordConfirm) {
         toast.error("Passwords do not match!");
         return;
       }
   
       try {
         const secretKey = await fetchSecretKey();
         const encryptedData = encryptBody(formData, secretKey);
         console.log("Encrypted Reset Password Payload:", encryptedData);
   
         const response = await axios.post("/api/resetPassword", encryptedData, {
           headers: { "Content-Type": "text/plain" },
         });
   
         if (response.status === 200) {
                 const decryptedResponse = decryptBody(response.data, secretKey);
           
                 if (!decryptedResponse) {
                   throw new Error("Decryption failed, no data returned.");
                 }
                 if (decryptedResponse.success) { // ✅ Fixed condition
                   toast.success("Password set Successful!");
                   
           
                   setTimeout(() => {
                     navigate(`/#`);
                   }, 100);
                 } else {
                   toast.error(decryptedResponse?.message ||  "Failed to reset password.");
                 }
               }
            } catch (error) {
  console.error("Registration Error:", error);

  const backendError = error.response?.data;

  // If backend sent an object like { success:false, message:"User not found." }
  if (backendError?.message) {
    toast.error(backendError.message);
  } 
  else {
    toast.error("Registration failed");
  }
}
           };
  return (
    <main>
      <div>
        <DashboardNavbar />
      </div>
      <header className="bg-dark">
        <div className="container-xl px-5">
          <h1 className="text-white py-3 mb-0 display-6">
            
          </h1>
        </div>
      </header>
      <div
        className="container-xl p-10 px-11"
        style={{ position: "relative", left: "100px" }}
      >
        &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mwc-tab-bar style={{ marginBottom: "-1px" }} activeIndex="3">
          <Link
            to="/users/subscriptionbilling"
            style={{ textDecoration: "none" }}
          >
            <mwc-tab
              label="Subscriptions"
              icon="account_balance"
              stacked
              onClick='location.href="app-account-billing.html"'
            ></mwc-tab>
          </Link>
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/users/notification" style={{ textDecoration: "none" }}>
            
            <mwc-tab
              label="Notifications"
              icon="notifications"
              stacked
              onClick='location.href="app-account-notifications.html"'
            ></mwc-tab>
          </Link>
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp; &ensp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <mwc-tab
            label="Security"
            icon="security"
            stacked
            activeIndex="3"
          ></mwc-tab>
        </mwc-tab-bar>
        <a href="/#/security" className="text-decoration-none">
  {/* <h3 className="text-white display-6 d-flex justify-content-center align-items-center gap-2">
    <span className="material-icons">security</span>
    SECURITY
  </h3> */}
</a>


       <hr className="mt-0 mb-5" />
      <div
        className="container-xl px-4"
        style={{
          padding: "10px",
          margin: "30px auto",
          textAlign: "center",
        }}
      >
        <h3 className="text-black py-3 mb-0 display-6">
          Account Settings - Security
        </h3>
      </div>
         <div className="row gx-5">
        <div className="col-lg-6">
          {/* First Card */}
        <div
  className="card card-raised mb-5"
  style={{
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "14px",
    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
    width: "850px",
    margin: "40px auto",
    fontSize: "16px",
    lineHeight: "1.8",
  }}
>
  <div
    className="card-title mb-3"
    style={{ fontWeight: "600", fontSize: "20px", color:"#2e7faeff" }}
  >
    Reset Password
  </div>
  <div
    className="card-subtitle mb-4"
    style={{ fontSize: "16px", color: "#6c757d" }}
  >
    New passwords must contain at least 8 characters.
  </div>

  <form onSubmit={(e) => handleSubmit(e)} className="d-flex flex-column">
    {/* Username */}
     <div className="mb-4">
   <label
        className="form-label"
        style={{ fontWeight: "500", display: "block", marginBottom: "6px" }}
      >
        Name
      </label>                <input
                  className="form-control"
                  type="text"
                  value={`${firstNameStored || ""} ${lastNameStored || ""}`} 
                  disabled
                  style={{
          fontSize: "15px",
          padding: "14px",
          borderRadius: "10px",
          border: "1px solid #ccc",
           background: "#e9ecef",
          width: "100%", // makes all inputs same width
        }}
                />
              </div>
              
    <div className="mb-4">
      <label
        className="form-label"
        style={{ fontWeight: "500", display: "block", marginBottom: "6px" }}
      >
        User Name
      </label>
      <input
        className="form-control"
        type="text"
        name="username"
        value={formData.username}
        onChange={handleChange}
        disabled 
        // placeholder="Enter your username"
        style={{
          fontSize: "15px",
          padding: "14px",
          borderRadius: "10px",
          border: "1px solid #ccc",
           background: "#e9ecef",
          width: "100%", // makes all inputs same width
        }}
      />
    </div>

    {/* New Password */}
    <div className="mb-4">
      <label
        className="form-label"
        style={{ fontWeight: "500", display: "block", marginBottom: "6px" }}
      >
        New Password
      </label>
      <input
        className="form-control"
        type="password"
        name="password"
        value={formData.password}
        onChange={handleChange}
        required
        placeholder="Enter new password"
        style={{
          fontSize: "15px",
          padding: "14px",
          borderRadius: "10px",
          border: "1px solid #ccc",
          width: "100%",
        }}
      />
    </div>

    {/* Confirm Password */}
    <div className="mb-4">
      <label
        className="form-label"
        style={{ fontWeight: "500", display: "block", marginBottom: "6px" }}
      >
        Confirm Password
      </label>
      <input
        className="form-control"
        type="password"
        name="passwordConfirm"
        value={formData.passwordConfirm}
        onChange={handleChange}
        required
        placeholder="Re-enter new password"
        style={{
          fontSize: "15px",
          padding: "14px",
          borderRadius: "10px",
          border: "1px solid #ccc",
          width: "100%",
        }}
      />
    </div>
<div style={{ height: "16px" }} />
    {/* Submit Button */}
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
  {/* Back Button */}
  <button
    type="button"
    className="btn btn-secondary"
    onClick={() => navigate(-1)} // Go back one step
    style={{
      padding: "10px 20px",
      borderRadius: "10px",
      fontSize: "16px",
      fontWeight: "500",
      cursor: "pointer",
     backgroundColor: "#2e7faeff",
     color: "#FFFFFF",
    border: "2px solid #FFFFFF",
    transition: "all 0.3s ease",
       minWidth: "150px", 
    }}
    onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#1e5f8eff";
    e.target.style.color = "#FFFFFF";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "#2e7faeff";
    e.target.style.color = "#FFFFFF";
  }}
  >
    Back
  </button>
    <button
  className="btn btn-primary"
  type="submit"
  //  disabled={userRole === "ROLE_SUPER"}   // 🔥 Disable button
  //  onClick={(e) => {
  //   if (userRole === "ROLE_SUPER") {
  //     e.preventDefault();   // stop form submission
  //     toast.warn("SUPER role password cannot be reset!");
  //     return;
  //   }
  // }}
  style={{
        padding: "10px 20px",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
       minWidth: "150px", 
    backgroundColor: "#2e7faeff",
    color: "#FFFFFF",
    border: "2px solid #FFFFFF",
    transition: "all 0.3s ease",
  }}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#1e5f8eff";
    e.target.style.color = "#FFFFFF";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "#2e7faeff";
    e.target.style.color = "#FFFFFF";
  }}
>
  Reset Password
</button>
</div>
  </form>
          </div>
          </div>
        </div>
      </div>
   
  </main>
  );
}
export default Security;